export enum RecommendationType {
  Leisure = 'get_leisure_recommendations',
  Ticketmaster = 'make_ticketmaster_reservation',
  Resort = 'get_resort_recommendations',
  MeetingRoom = 'get_groups_events_info_venues',
}
